import Cache from 'root/cache';

export function loadCustomData(success, complete) {
    Cache.app.request({
        action: 'session_recording/getCustomData',
        data: {},
        success: (response) => {
            if (typeof success === 'function') {
                success(response);
            }
        },
        complete: () => {
            if (typeof complete === 'function') {
                complete();
            }
        }
    });
}

export function updateCustomData(data, success, complete) {
    Cache.app.request({
        action: 'session_recording/updateCustomData',
        data: data,
        success: (response) => {
            if (typeof success === 'function') {
                success(response);
            }
        },
        complete: () => {
            if (typeof complete === 'function') {
                complete();
            }
        },
        error: () => {
            // ignore error
        }
    });
}